import React, { FC } from "react";
import { CircularProgress } from "@mui/material";

import { ButtonProps } from "./models";

import { ButtonStyled, LoaderStyled } from "./styles";

const Button: FC<ButtonProps> = ({ children, loading, ...props }) => {
  if (loading) {
    return (
      <LoaderStyled>
        <CircularProgress size="24px" />
      </LoaderStyled>
    );
  }
  return <ButtonStyled {...props}>{children}</ButtonStyled>;
};

export default Button;
